module.exports = __webpack_public_path__ + "img/2icono_portafolio.bdac8b9c.svg";